import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { APP_CONFIG } from "@core/constants/app.config";
import { AppRootComponent } from "./app/app-root.component";


bootstrapApplication(AppRootComponent, {...APP_CONFIG, providers: [provideZoneChangeDetection(), ...APP_CONFIG.providers]})
// eslint-disable-next-line @tseslint/dot-notation, no-console, @unicorn/prefer-top-level-await
  .catch(console.error);
